import { BaseAppConstants } from '@app/base-app-constants';
/**
 * Write all your custom app constants here
 */
export class AppConstants extends BaseAppConstants {
    public static dateFormat = 'dd-MMM-yyyy';
    static lookupSortField: any;
    static lookupSortOrder: any;
}